/**
 * Store names
 */ export var Store = /*#__PURE__*/ function(Store) {
    Store["Auth"] = "auth";
    Store["Activity"] = "activity";
    Store["AppContext"] = "appContext";
    Store["Bucket"] = "bucket";
    Store["Campaign"] = "campaign";
    Store["Capabilities"] = "capabilities";
    Store["Chat"] = "chat";
    Store["ChildView"] = "childView";
    Store["CreateTaskFromMessage"] = "createTaskFromMessage";
    Store["CustomFieldDefinition"] = "customFieldDefinition";
    Store["ExternalAgent"] = "externalAgent";
    Store["Dependency"] = "dependency";
    Store["DriveItem"] = "driveItem";
    Store["DynamicFilter"] = "dynamicFilter";
    Store["Goal"] = "goal";
    Store["GroundingResource"] = "groundingResource";
    Store["GroupConversations"] = "groupConversations";
    Store["History"] = "history";
    Store["Intelligence"] = "intelligence";
    Store["ModernGroups"] = "modernGroups";
    Store["Mru"] = "mru";
    Store["Modal"] = "modal";
    Store["Navigation"] = "navigation";
    Store["NewsBar"] = "newsBar";
    Store["Notification"] = "notification";
    Store["OperationTracking"] = "operationTracking";
    Store["Org"] = "org";
    Store["PerformanceCollection"] = "performanceCollection";
    Store["Permissions"] = "permissions";
    Store["PinnedTasks"] = "pinnedTasks";
    Store["Plan"] = "plan";
    Store["PlanCalendarNudge"] = "planCalendarNudge";
    Store["PlanConversion"] = "planConversion";
    Store["Portfolio"] = "portfolio";
    Store["PremiumPlan"] = "premiumPlan";
    Store["PremiumPlanPermissions"] = "premiumPlanPermissions";
    Store["RecommendedPlans"] = "recommendedPlans";
    Store["Roster"] = "roster";
    Store["Route"] = "route";
    Store["StatusReport"] = "statusReport";
    Store["SuiteNav"] = "suiteNav";
    Store["TaskOrder"] = "taskOrder";
    Store["Tasks"] = "tasks";
    Store["Teams"] = "teams";
    Store["TeamsChannel"] = "teamsChannel";
    Store["Template"] = "template";
    Store["Tenant"] = "tenant";
    Store["Todo"] = "todo";
    Store["Trouter"] = "trouter";
    Store["UndoRedo"] = "undoRedo";
    Store["Upsell"] = "upsell";
    Store["User"] = "user";
    Store["View"] = "view";
    Store["ViewLifecycle"] = "viewLifecycle";
    return Store;
}({});
